define('bizzabo/models/Speaker',[
    'bizzabo/bzapi',
    'bizzabo/utils',
    'underscore',
    'backbone',
    'backbone-validation',
    'GSModel',
    'bizzabo/models/ValidationObject'
], function(
    BZAPI,
    UTILS,
    _,
    Backbone,
    BackboneValidation,
    GSModel,
    ValidationObject
    ) {

    var Speaker = GSModel.extend({
        relationType: 'speaker',
        defaults : {
            'photo-url' : ''
        },
        validationObject : undefined,

        initialize : function() {
            this.validationObject = new ValidationObject(this);
        },

        getters : {},

        setters : {
            'website' : function(value) {
                var valueWithHTTP = 'http://' + value;
                return (Backbone.Validation.patterns.url.test(valueWithHTTP)) ? valueWithHTTP : value;
            },
            'blog' : function(value) {
                var valueWithHTTP = 'http://' + value;
                return (Backbone.Validation.patterns.url.test(valueWithHTTP)) ? valueWithHTTP : value;
            },
            'linkedin-profile-url' : function(value) {
                var valueWithHTTP = 'http://' + value;
                return (Backbone.Validation.patterns.url.test(valueWithHTTP)) ? valueWithHTTP : value;
            }
        },

        parse : function(response) {
            return this.unfoldPhotoSet(this.unfoldMarkersData(response));
        },

        equals : function(otherSpeaker) {
            var attrs = ['first-name', 'last-name', 'company', 'title'];
            var isEqual = true;
            var thisModel = this;
            _.each(attrs, function(attr) {
                if (thisModel.get(attr) != otherSpeaker.get(attr)) {
                    isEqual = false;
                }
            });
            return isEqual;
        },

        getFullName : function() {
            var fullName = _.compact([
                this.get('first-name'),
                this.get('last-name')
            ]).join(' ');

            if (fullName.length == 0) {
                fullName = 'Nameless speaker';
            }
            return fullName;
        },

        // Validation

        validation : {
            email: [
                {
                    required : true,
                    msg : 'Email is required'
                },
                {
                    pattern : 'email',
                    msg : 'Email is invalid'
                }
            ],
            'first-name' : [
                {
                    required : false
                }
            ],
            'last-name' : [
                {
                    required : false
                }
            ],
            'title' : [
                {
                    required : false
                }
            ],
            'company' : [
                {
                    required : false
                }
            ],
            'photo-url' : {
                required : false,
                maxLength : 255,
                pattern : 'url',
                msg : 'Photo URL is invalid'
            },
            'website' : {
                required : false,
                pattern : 'url',
                msg : 'Website address is invalid'
            },
            'blog' : {
                required : false,
                pattern : 'url',
                msg : 'Blog address is invalid'
            },
            'linkedin-profile-url' : {
                required : false,
                pattern : 'url',
                msg : 'Address is invalid'
            },
            'bio' : {
                required : false
            },
            'twitter-handle' : [
                {
                    required : false
                },
                {
                    pattern : 'twitterScreenName',
                    msg : 'Twitter name is invalid'
                }
            ]
        },

        unfoldMarkersData : function(attrs) {
            return UTILS.unfoldAttribute(attrs, 'markers-data');
        },

        unfoldPhotoSet : function(attrs) {
            return UTILS.unfoldAttribute(attrs, 'photo-set');
        }

    });

    return Speaker;

});
